import { MaterialService } from './../../../../../../shared/src/lib/service/material.service';
import { RateStudentService } from './../../../../../../shared/src/lib/service/rate-student.service';
import { HttpParams } from '@angular/common/http';
import { SessionService } from './../../../../../../shared/src/lib/service/session.service';
/**
 * Composant pour les informations générale de la formation/training.
 */

import { Component, OnInit, OnDestroy } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { FormationService } from '../../../../../../shared/src/lib/service/formation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../../../../../shared/src/lib/service/authentification.service';

import { ReportService } from '../../../reports/report.service';
import { OccurrenceService } from '../../../../../../shared/src/lib/service/occurrence.service';
import { ChartOptions } from 'chart.js';
@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class InfoComponent implements OnInit, OnDestroy {
  selfReportedLevel;
  defaultAvatar = environment.static + '/avatar.png';
  formation_id: any;
  formation: any;
  teachers: any[] = [];
  myUser: any;
  currentOccurrence: any;
  currentReport = null;
  currentSession = null;
  showDetails = false;
  callServiceFormationId = null;
  translatePath = 'teacher.trainings';

  /** RADAR variables **/
  public radarChartData: any = [{
    data: [],
    labels: [],
    backgroundColor: 'rgba(0, 151, 167, 1)',
    borderColor: '#0097a7',
    pointBackgroundColor: '#276073',
    pointBorderColor: '#276073',
    pointHoverBackgroundColor: '#276073',
    pointHoverBorderColor: '#276073',
    pointRadius: 0
  }, { 
    data: [],
    labels: [],
    backgroundColor: 'rgba(211, 211, 211, 0.5)',
    borderColor: 'rgba(211, 211, 211, 0)',
    pointBackgroundColor: '#276073',
    pointBorderColor: '#276073',
    pointHoverBackgroundColor: '#276073',
    pointHoverBorderColor: '#276073',
    pointRadius: 0
  }];
  radarChartType = 'radar';
  radarOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      r: {
        display: true,
        min: 0,
        max: 100,
        ticks: {
          display: false,          
          stepSize: 20,
          maxTicksLimit: 7
        },
        angleLines: {
          display: true,
          color: '#0097a7', 
        },
        grid: {
          display: false,
        }
      }
    }
  }

  evaluation_connection = [
    { label: 'A1', value: 10 },
    { label: 'A2', value: 20 },
    { label: 'B1', value: 40 },
    { label: 'B2', value: 60 },
    { label: 'C1', value: 80 },
    { label: 'C2', value: 100 }
  ]

  constructor(
    private formationService: FormationService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private reportService: ReportService,
    private occurrenceService: OccurrenceService,
    private sessionService: SessionService,
    private route: ActivatedRoute,
    private rateStudentService: RateStudentService,
    private materialService: MaterialService
    ,) { }

  ngOnInit() {
    this.route.parent.paramMap.subscribe(param => {
      this.formation_id = this.route.parent.snapshot.params.id_formation;
      this.authenticationService.currentUserSubject.subscribe(
        user => {
          if (user && user.hasOwnProperty('user') && this.formation_id) {
            this.myUser = user;
            this.callServiceFormationId = this.formationService.getObservableFormationById(this.formation_id)
              .subscribe(_formation => {
                this.formation = _formation;
                this.setTeachers();
                this.setCurrentRateTeacher();
                this.setCecrlLevelSrc();
              })
          }
        }
      )
    })
  }

  setCecrlLevelSrc() {
    this.selfReportedLevel = this.rateStudentService.selfReportedLevelToCecrl(this.formation.niveau);
  }

  ngOnDestroy() {
    if (this.callServiceFormationId) {
      this.callServiceFormationId.unsubscribe();
    }
  }

  setCurrentRateTeacher() {
    const params = new HttpParams().set('formation', this.formation_id);
    this.sessionService.getObservableSessions(params).subscribe(_sessions => {
      for (let i = 0; i < _sessions.length; i++) {
        const _session = _sessions[i];
        if (_session) {
          if (_session.rate_teacher && _session.rate_teacher.status === 'completed') {
            this.currentSession = _session;
            this.currentReport = this.reportService.getLastReportData(_session.rate_teacher);
            this.occurrenceService.getObservableOccurence(this.currentSession.occurrence)
              .subscribe(_occurrence => {
                this.currentOccurrence = _occurrence;
                this.buildProgressionData()
              })
            break
          }
        }
      }
    });
  }

  /**
   * Methode pour construire la liste de sprofs a afficher
   */
  setTeachers() {
    this.teachers = [];
    // le premier doit etre le currentUser
    const myTeacher = this.formation.teachers.filter(_teacher => _teacher.user.id === this.myUser.user.id)
    this.teachers.push(myTeacher[0]);
    this.formation.teachers.forEach(_teacher => {
      if (_teacher.user.id !== this.myUser.user.id) {
        this.teachers.push(_teacher);
      }
    });
  }

  gotoProfil(idx, teacher) {
    if (idx > 0) {
      this.router.navigate(['trainings', 'teacher-profil', teacher.id]);
    }
  }

  buildProgressionData() {
    this.radarChartData[0].data.push(this.computeEvaluation(this.currentOccurrence.session.rate_teacher.level_grammar));
    this.radarChartData[0].data.push(this.computeEvaluation(this.currentOccurrence.session.rate_teacher.level_expression));
    this.radarChartData[0].data.push(this.computeEvaluation(this.currentOccurrence.session.rate_teacher.level_comprehension));
    this.radarChartData[0].data.push(this.computeEvaluation(this.currentOccurrence.session.rate_teacher.level_vocabulary));
    this.radarChartData[0].data.push(this.computeEvaluation(this.currentOccurrence.session.rate_teacher.level_accent));
    this.radarChartData[0]['labels'] = [
      'Grammaire - ' + this.currentOccurrence.session.rate_teacher.level_grammar + ' : ' + Math.round(this.currentOccurrence.session.rate_teacher.grammar) + '%',
      'Expression - ' + this.currentOccurrence.session.rate_teacher.level_expression + ' : ' + Math.round(this.currentOccurrence.session.rate_teacher.expression) + '%',
      'Comprehension - ' + this.currentOccurrence.session.rate_teacher.level_comprehension + ' : ' + Math.round(this.currentOccurrence.session.rate_teacher.comprehension) + '%',
      'Vocabulaire - ' + this.currentOccurrence.session.rate_teacher.level_vocabulary + ' : ' + Math.round(this.currentOccurrence.session.rate_teacher.vocabulary) + '%',
      'Accent - ' + this.currentOccurrence.session.rate_teacher.level_accent + ' : ' + Math.round(this.currentOccurrence.session.rate_teacher.accent) + '%',
    ];
    this.radarChartData[1]['data'] = [100, 100, 100, 100, 100];
    this.radarChartData[1]['labels'] = [
      'Grammaire - ' + this.currentOccurrence.session.rate_teacher.level_grammar + ' : ' + Math.round(this.currentOccurrence.session.rate_teacher.grammar) + '%',
      'Expression - ' + this.currentOccurrence.session.rate_teacher.level_expression + ' : ' + Math.round(this.currentOccurrence.session.rate_teacher.expression) + '%',
      'Comprehension - ' + this.currentOccurrence.session.rate_teacher.level_comprehension + ' : ' + Math.round(this.currentOccurrence.session.rate_teacher.comprehension) + '%',
      'Vocabulaire - ' + this.currentOccurrence.session.rate_teacher.level_vocabulary + ' : ' + Math.round(this.currentOccurrence.session.rate_teacher.vocabulary) + '%',
      'Accent - ' + this.currentOccurrence.session.rate_teacher.level_accent + ' : ' + Math.round(this.currentOccurrence.session.rate_teacher.accent) + '%',
    ];

  }

  computeEvaluation(_level) {
    return this.evaluation_connection.filter(_eval => _eval.label === _level)[0].value;
  }

}
